import { connect } from "react-redux";

import { ExportAlertModal } from "./ExportAlertModal";
import type { Dispatch } from "redux";

import type { DateRange } from "@cobliteam/common-types";

import { isWebDataFetching, type WebData } from "@cobliteam/api-lib";

import {
  type AppState,
  downloadIncidentsReportRequest,
  selectIncidentsReport,
} from "@cobliteam/store";

interface StateProps {
  incidentsReportWebData: WebData<void>;
  loading: boolean;
}

interface DispatchProps {
  downloadIncidentsReport: (period: DateRange) => void;
}

const mapStateToProps = (state: AppState): StateProps => {
  const incidentsReportWebData = selectIncidentsReport(state);
  return {
    incidentsReportWebData,
    loading: isWebDataFetching(incidentsReportWebData),
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  downloadIncidentsReport: (period: DateRange) => {
    dispatch(downloadIncidentsReportRequest(period));
  },
});

export const ExportAlertModalContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  // TODO TSC: fix "as any" on next line.
)(ExportAlertModal as any);
